<template>
  <v-card class="pa-4">
    <div class="d-flex align-center justify-space-between mb-4">
      <h3>Select Business Manager</h3>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-select
      v-model="selectedBmId"
      :items="formattedBmList"
      item-text="displayName"
      item-value="id"
      outlined
      dense
      :loading="isLoadingBms"
    ></v-select>

    <div class="d-flex justify-end mt-4">
      <v-btn text @click="$emit('close')" class="mr-2">Cancel</v-btn>
      <v-btn color="primary" depressed :disabled="!selectedBmId" :loading="isPublishing" @click="onPublish">
        Publish
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import { catalogService } from '@/apis/catalog';
import { feedService } from '@/apis/feed';

export default {
  name: 'BmDialog',
  props: {
    feed: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedBmId: null,
      bmList: [],
      isLoadingBms: false,
      isPublishing: false,
    };
  },
  computed: {
    formattedBmList() {
      return this.bmList.map(bm => ({
        ...bm,
        displayName:
          bm.business_name && bm.business_id
            ? `${bm.business_name} (${bm.business_id})`
            : bm.business_name || bm.business_id || '',
      }));
    },
  },
  methods: {
    async getFbBms() {
      try {
        this.isLoadingBms = true;
        const { data, status } = await catalogService.getFbBms({ page: 1, limit: 100 });
        if (status === 200) {
          this.bmList = data.data || [];
          if (this.bmList.length > 0) {
            this.selectedBmId = this.bmList[0].id;
          }
        }
      } catch (error) {
        console.error('Failed to load BMs:', error);
        this.$store.dispatch('setMessage', {
          color: 'error',
          dialog: true,
          content: 'Failed to load Business Managers',
        });
      } finally {
        this.isLoadingBms = false;
      }
    },
    async onPublish() {
      if (!this.selectedBmId) return;
      try {
        this.isPublishing = true;

        const payload = {
          fb_catalog_id: this.feed._id,
          fbBmId: this.selectedBmId,
        };
        await feedService.publishFBCatalog(payload);

        this.$emit('close', true);
      } catch (error) {
        console.error('Failed to publish catalog:', error);
      } finally {
        this.isPublishing = false;
      }
    },
  },
  mounted() {
    this.getFbBms();
  },
};
</script>
